<template>
  <v-card>
    <userToolbar />
    <v-list class="users_list pb-0" v-if="usersList">
      <div>
        <v-list-tile>
          <v-layout row class="caption" :class="paddingClass">
            <ListIcon
              :additionalClass="'hidden-sm-and-down'"
            ></ListIcon>
            <v-flex xs12 md4
              v-if="!isMobile || sort_by === 'name'"
              class="font-weight-medium">
              Nazwa

              <v-btn small flat icon
                     v-if="sort_by !== 'name'"
                     @click.prevent="setSort('name', 'asc')"
                     color="grey"
                     class="ma-0">
                <v-icon small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'name' && sort_dir === 'asc'"
                     @click.prevent="setSort('name', 'desc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  v-if="sort_dir === 'asc'"
                  small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'name' && sort_dir === 'desc'"
                     @click.prevent="setSort('name', 'asc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  small>arrow_downward</v-icon>
              </v-btn>

            </v-flex>
            <v-flex xs12 md3
              v-if="!isMobile || sort_by === 'email'"
              class="font-weight-medium">
              E-mail
              <v-btn small flat icon
                     v-if="sort_by !== 'email'"
                     @click.prevent="setSort('email', 'asc')"
                     color="grey"
                     class="ma-0">
                <v-icon small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'email' && sort_dir === 'asc'"
                     @click.prevent="setSort('email', 'desc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  v-if="sort_dir === 'asc'"
                  small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'email' && sort_dir === 'desc'"
                     @click.prevent="setSort('email', 'asc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  small>arrow_downward</v-icon>
              </v-btn>

            </v-flex>
            <v-flex xs12 md2
              v-if="!isMobile || sort_by === 'status'"
              class="font-weight-medium">
              Status

              <v-btn small flat icon
                     v-if="sort_by !== 'status'"
                     @click.prevent="setSort('status', 'asc')"
                     color="grey"
                     class="ma-0">
                <v-icon small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'status' && sort_dir === 'asc'"
                     @click.prevent="setSort('status', 'desc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  v-if="sort_dir === 'asc'"
                  small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'status' && sort_dir === 'desc'"
                     @click.prevent="setSort('status', 'asc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  small>arrow_downward</v-icon>
              </v-btn>

            </v-flex>
            <v-flex xs12 md2
              v-if="!isMobile || sort_by === 'client_name'"
              class="font-weight-medium">
              Klient

              <v-btn small flat icon
                     v-if="sort_by !== 'client_name'"
                     @click.prevent="setSort('client_name', 'asc')"
                     color="grey"
                     class="ma-0">
                <v-icon small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'client_name' && sort_dir === 'asc'"
                     @click.prevent="setSort('client_name', 'desc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  v-if="sort_dir === 'asc'"
                  small>arrow_upward</v-icon>
              </v-btn>

              <v-btn small flat icon
                     v-if="sort_by === 'client_name' && sort_dir === 'desc'"
                     @click.prevent="setSort('client_name', 'asc')"
                     :color="'primary'"
                     class="ma-0">
                <v-icon
                  small>arrow_downward</v-icon>
              </v-btn>

            </v-flex>

            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-btn flat icon
               :color="'primary'"
               @click="sortVisibility = true"
               class="ma-0 hidden-md-and-up align-sort">
              <v-icon>sort</v-icon>
            </v-btn>
          </v-layout>
        </v-list-tile>
        <v-divider></v-divider>
      </div>
      <UserItem v-for="(user, i) in usersList" :key="i" :index="i" :user="user" />
      <div v-if="usersList && usersList.length === 0" class="px-4 py-4">
        <p class="mb-0 grey--text text--darken-1 subheading font-weight-bold">
          Brak użytkowników spełniających podane kryteria.
        </p>
      </div>
    </v-list>
    <ClientLockDialog />
    <ClientActivateDialog />
    <ClientDeleteDialog />
    <div class="users_loader" v-if="!usersList">
      <div class="py-4 text-xs-center">
        <v-progress-circular
          :size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <v-bottom-sheet v-model="sortVisibility">
      <v-list>
        <v-subheader>Sortuj według:
          <v-spacer></v-spacer>
          <v-btn
            @click.native="sortVisibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-tile
          :class="sort_by === 'name' ? 'primary white--text' : ''"
          @click.prevent="setSort('name', 'asc')"
        >
          <v-list-tile-title>
            Nazwie
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('email', 'asc')"
          :class="sort_by === 'email' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            E-mailu
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('status', 'asc')"
          :class="sort_by === 'status' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Statusie
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('client_name', 'asc')"
          :class="sort_by === 'client_name' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Kliencie
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ClientLockDialog from './Dialogs/UserLockDialog.vue';
import ClientActivateDialog from './Dialogs/UserActivateDialog.vue';
import ClientDeleteDialog from './Dialogs/UserDeleteDialog.vue';
import ListIcon from '../common/ListIcon.vue';
import userToolbar from './UsersToolbar.vue';
import UserItem from './UsersItem.vue';

export default {
  name: 'users-list',
  props: ['user'],
  data: () => ({
    sort_by: 'name',
    sort_dir: 'asc',
    sortVisibility: false,
    busy: false,
  }),
  components: {
    UserItem,
    ListIcon,
    userToolbar,
    ClientLockDialog,
    ClientActivateDialog,
    ClientDeleteDialog,
  },
  computed: {
    ...mapGetters('users', [
      'usersList',
      'currentPage',
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    paddingClass() {
      return this.isMobile ? 'px-0' : 'px-2';
    },
  },
  methods: {
    setSort(name, dir) {
      this.sort_dir = dir;
      this.sort_by = name;
      const { query } = this.$route;
      const newQuery = {
        ...query,
        sort_by: name,
        sort_dir: dir,
      };
      this.sortVisibility = false;
      this.$router.push({ path: `/uzytkownicy/${this.currentPage}`, query: newQuery });
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.sort_dir) {
      this.sort_dir = query.sort_dir;
    }
    if (query.sort_dir) {
      this.sort_by = query.sort_by;
    }
  },
};
</script>
